import {
    IInGameCampaign
} from "../firebase/topics/in-game-challenges/add-to-campaign/add-to-campaign-topic.model.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {IFirebaseTopicRegistration} from "../firebase/topics/firebase-topic-view-model.interface";
import {
    IIGCLiveProgressUpdateData
} from "../firebase/topics/in-game-challenges/live-progress-update/live-progress-update-topic.model.interface";

export class InGameChallengeCampaignModel {
    constructor(campaignData: IInGameCampaign,
                private readonly services: IServiceFactoryExtended) {

        this._campaignData = campaignData;
        makeObservable(this)
    }


    dispose(): void {
        this.stopProgressSubscription();
    }

    @observable.ref
    private _campaignData: IInGameCampaign

    get id(): number {
        return this._campaignData.CampaignId;
    }

    get startDate(): Date {
        return new Date(this._campaignData.CampaignStartDate);
    }

    get endDate(): Date {
        return new Date(this._campaignData.CampaignExpirationDate);
    }

    get isActive(): boolean {
        const now = this.services.time.now();
        return this.startDate.getTime() <= now && this.endDate.getTime() > now;
    }

    updateData(campaignData: IInGameCampaign): void {
        runInAction(() => {
            this._campaignData = campaignData;
        });

    }

    private _progressTopicSubscription: IFirebaseTopicRegistration | null = null;
    startProgressSubscription(): void {
        const topic = this.services.firebase.topics.inGameChallengesLiveProgress.getLiveProgressForCampaign(this.id);

        this._progressTopicSubscription = topic.registerListener(this._onLiveProgressUpdate);
    }

    stopProgressSubscription(): void {
        this._progressTopicSubscription?.unregister();
        this._progressTopicSubscription = null;
    }

    private _onLiveProgressUpdate = (progressUpdate: IIGCLiveProgressUpdateData) => {

            this.progressPercentage = Math.floor((progressUpdate.RuleCompletedActions / progressUpdate.RuleRequiredActions) * 100);

            this.services.logger.debug(`InGame Challenge: recived live progress update for campaign ${progressUpdate.CampaignId}: ${JSON.stringify(progressUpdate, null, 2)}`);
        }

    @observable.ref
    private _progressPercentage = 0;
    get progressPercentage(): number {
        return this._progressPercentage;
    }

    private set progressPercentage(value: number) {
        runInAction(() => {
            this._progressPercentage = value;
        });
    }

}